import { useState, useEffect } from "react";
import { useDataContext } from "../Context/dataContext";

function useFetchPointRedemptions(accessToken) {
  const { url } = useDataContext();
  const [redemptions, setRedemptions] = useState([]);
  const [loadingRedemptions, setLoadingRedemptions] = useState(true);
  const [errorRedemptions, setErrorRedemptions] = useState(null);

  useEffect(() => {
    if (!accessToken || !url) return;

    setLoadingRedemptions(true);
    setErrorRedemptions(null);

    const fetchRedemptions = async () => {
      try {
        const res = await fetch(`${url}/PointRedemption/withPersonality`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });

        if (!res.ok) throw new Error("Error al obtener los canjes de puntos");
        const data = await res.json();

        // Ordenamos por fecha descendente
        data.sort((a, b) => new Date(b.pr_date) - new Date(a.pr_date));

        setRedemptions(data);
      } catch (err) {
        setErrorRedemptions(err);
      } finally {
        setLoadingRedemptions(false);
      }
    };

    fetchRedemptions();
  }, [accessToken, url]);

  return { redemptions, loadingRedemptions, errorRedemptions };
}

export { useFetchPointRedemptions };
